module.exports = __webpack_public_path__ + "static/media/errorBoundaryImage.4f7ddbcd.svg";